export class ValidationMessages {
  static messages() {
    return {
      'your_name': [
        { type: 'required', message: 'Your name required'}
      ],
      'email': [
        { type: 'required', message: 'Your email required'},
      ],
      'message': [
        { type: 'required', message: 'Your message required'},
      ],
    };
  }
}
